export default __webpack_public_path__ + "static/flameretardant-6db761acad335ec4d9ea8a4dd6dcfa43.jpg";